import { Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { Activity } from './activity.resource';
import { Firm } from './firm.resource';
import { InternetServiceProvider } from './internet-service-provider.resource';
import { MobileNetworkOperator } from './mobile-network-operator.resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { PaymentMethods } from './payment-methods.resource';

@Resource({
  type: 'jobs',
})
export class Job extends AtomResource {
  @Relationship() firm?: Firm;
  @Relationship() activity?: Activity;
  @Relationship() internetserviceproviders?: InternetServiceProvider[];
  @Relationship() mobilenetworkoperators?: MobileNetworkOperator[];
  @Relationship() paymentmethods?: PaymentMethods[];

  get defaultISP(): InternetServiceProvider | undefined {
    return this.internetserviceproviders?.find((provider) => provider.default);
  }

  get defaultMNO(): MobileNetworkOperator | undefined {
    return this.mobilenetworkoperators?.find((provider) => provider.default);
  }
}

export class JobConfig implements ResourceConfig {
  hosted = 'firm';
  tables = {
    includes: [
      'internetserviceproviders.job',
      'mobilenetworkoperators.job',
      'firm.headquarterscountry',
      'activity',
    ],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        displayed: true,
      },
      {
        columnDef: 'activity',
        displayedDatas: [{ path: ['activity.name'], class: 'main' }],
        header: 'Activity',
        displayed: true,
      },
      {
        columnDef: 'internetserviceproviders',
        displayedDatas: [
          {
            path: [
              'internetserviceproviders.name',
              'internetserviceproviders.asn',
            ],
            class: 'mat-body-2',
            type: 'chips',
          },
        ],
        header: 'ISP',
        displayed: true,
      },
    ],
  };
  wizard = {};
  resource = Job;
  resourceName = 'Job';
  resourceKey = 'jobs';
  resourceKeySingle = 'job';
  includes = [
    'internetserviceproviders.job',
    'mobilenetworkoperators.job',
    'firm.headquarterscountry',
    'activity',
  ];
}
